import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取账户信息
export const getAccountCash = async (params: object) => {
  return await POST({
    url: Api.getAccountCash,
    params: {
      ...params
    },
    showError: false
  })
}
// 正常提现
export const toWithDrawal = async (params: object) => {
  return await POST({
    url: Api.toWithDrawal,
    params: {
      ...params
    },
    showError: false
  })
}
// 帮买提现
export const helpBuyToWithDrawal = async (params: object) => {
  return await POST({
    url: Api.helpBuyToWithDrawal,
    params: {
      ...params
    },
    showError: false
  })
}

// 新获取账户信息
export const queryCourierAccountBindInfo = async (params: object) => {
  return await POST({
    url: Api.queryCourierAccountBindInfo,
    params: {
      ...params
    },
    showError: false
  })
}

// 获取支付宝体现手续费
export const courierApplyWithDraw = async (params: object) => {
  return await GET({
    url: Api.courierApplyWithDraw,
    params: {
      ...params
    },
    showError: false
  })
}

// 支付宝授权
export const aliPayOauthToken = async (params: object) => {
  return await POST({
    url: Api.aliPayOauthToken,
    params: {
      ...params
    },
    showError: false
  })
}

// 判断是否命中强制提现白名单
export const queryCancelSwitch = async (params: object) => {
  return await GET({
    url: Api.queryCancelSwitch,
    params: {
      ...params
    },
    showError: false
  })
}

// 获取提现银行卡列表
export const queryWithdrawBankCard = async (params: object) => {
  return await GET({
    url: Api.queryWithdrawBankCard,
    params: {
      ...params
    },
    showError: false
  })
}

// 计算银行卡提现手续费
export const caculateWithdrawFee = async (params: object) => {
  return await POST({
    url: Api.caculateWithdrawFee,
    data: {
      ...params
    },
    showError: false,
    headers: {
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}

// 闪送员银行卡提现次数
export const withdrawCount = async (params: object) => {
  return await POST({
    url: Api.withdrawCount,
    data: {
      ...params
    },
    showError: false,
    headers: {
      'Content-Type': 'application/json'
    },
    dataType: 'json'
  })
}
